var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 3.65625H2.25C1.78875 3.65625 1.40625 3.27375 1.40625 2.8125C1.40625 2.35125 1.78875 1.96875 2.25 1.96875H24.75C25.2113 1.96875 25.5938 2.35125 25.5938 2.8125C25.5938 3.27375 25.2113 3.65625 24.75 3.65625Z",
    fill: "#161F28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12891 2.8125V16.2788C4.12891 17.3813 4.64641 18.4275 5.53516 19.0912L11.3964 23.4788C12.6452 24.4125 14.3664 24.4125 15.6152 23.4788L21.4764 19.0912C22.3652 18.4275 22.8827 17.3813 22.8827 16.2788V2.8125H4.12891ZM18.0002 15.4688H9.00016C8.53891 15.4688 8.15641 15.0863 8.15641 14.625C8.15641 14.1637 8.53891 13.7812 9.00016 13.7812H18.0002C18.4614 13.7812 18.8439 14.1637 18.8439 14.625C18.8439 15.0863 18.4614 15.4688 18.0002 15.4688ZM18.0002 9.84375H9.00016C8.53891 9.84375 8.15641 9.46125 8.15641 9C8.15641 8.53875 8.53891 8.15625 9.00016 8.15625H18.0002C18.4614 8.15625 18.8439 8.53875 18.8439 9C18.8439 9.46125 18.4614 9.84375 18.0002 9.84375Z",
    fill: "#161F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBill);
export default __webpack_public_path__ + "static/media/bill.ae48839360bcb5e938ff06bddb72d783.svg";
export { ForwardRef as ReactComponent };